export enum ActionDoneType {
  SHARE = 'SHARE',
  CERTIFY = 'CERTIFY',
  CERTIFY_REQUEST = 'CERTIFY_REQUEST',
  TRANSFER = 'TRANSFER',
  OPENDATA_SYNC = 'OPENDATA_SYNC'
}
